import React, { useEffect, useState } from "react";
import CardComponent from "../cardComponents/CardComponent";
import AccordionComponent from "../accordion/AccordionComponent";
// import { CreditCardData } from './CardData'
import Http from "../../Http";
import { CARD_API } from "../../Helper";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import {
  FaUserCheck,
  FaIdCard,
  FaExternalLinkAlt,
  FaListAlt,
  FaCheckCircle,
  FaFileUpload,
} from "react-icons/fa";
import FAQSchema from "../../FAQSchema";
import { BadgeCheck, FileText } from "lucide-react";
import AdBanner from "../AdPage/AdBanner";
const Federal = () => {
  const [CreditCardData, setCreditCardData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage] = useState(10);
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };
  function Icon({ id, open }) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className={`${
          id === open ? "rotate-180" : ""
        } h-5 w-5 transition-transform`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M19.5 8.25l-7.5 7.5-7.5-7.5"
        />
      </svg>
    );
  }

  useEffect(() => {
    Http.post(CARD_API)
      .then((res) => {
        setCreditCardData(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  console.log({ indexOfLastCard, indexOfFirstCard });
  const currentCards = CreditCardData.cards
  ?.filter((card) => card.title?.toLowerCase().includes("fedral"))
  .slice(indexOfFirstCard, indexOfLastCard);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const faqs = [
    {
      question:
        "Are Federal Bank credit cards suitable for international travel?",
      answer:
        "  Yes, many Federal Bank cards have low forex markups (as low as 1.99%) and global acceptance, ideal for frequent travelers.",
    },
    {
      question: "Does Federal Bank offer lifetime free credit cards?",
      answer:
        "  Yes, select cards are lifetime free, especially if you're a loyal Federal Bank customer or meet spend-based conditions.",
    },
    {
      question:
        "How do I track my Federal Bank credit card application status?",
      answer:
        "  You can track the status through Federal Bank’s online portal using your reference number and registered mobile number.",
    },
    {
      question:
        "Can I get a credit card without an existing Federal Bank account?",
      answer:
        "  Yes, while having an account helps, it is not mandatory. However, existing customers may receive faster approvals.",
    },
    {
      question:
        "What is the typical approval time for Federal Bank credit cards?",
      answer:
        "    Approvals usually take 5–7 working days, and you’ll receive your card within 7–10 days post-approval.",
    },
  ];

  const steps = [
    {
      icon: <FaCheckCircle className="h-6 w-6 text-orange-500" />,
      title: "Confirm Eligibility Requirements",
      description:
        "   Cross-check your income, age, and credit score against the card’s requirements to ensure eligibility and avoid rejections.",
    },
    {
      icon: <FaFileUpload className="h-6 w-6 text-green-500" />,
      title: "Arrange All Necessary Documents",
      description:
        "    Keep your ID, address proof, PAN, and income documents ready for quick application and verification.",
    },
    {
      icon: <FaExternalLinkAlt className="h-6 w-6 text-purple-600" />,
      title: "Apply via Federal Bank’s Official Portal",
      description:
        "   Clicking the “Apply Now” button will securely redirect you to Federal Bank’s official website, where you can complete the application in a few simple steps.",
    },
    {
      icon: <FaListAlt className="h-6 w-6 text-teal-500" />,
      title: "Explore & Compare with TheFinMaster",
      description:
        "    Navigate through our handpicked collection of Federal Bank credit cards on TheFinMaster. Each card listing highlights features, fees, ideal users, and reward systems—making your selection process easy and informed.",
    },
  ];
  return (
    <>
      <Helmet>
        <title>
        Federal Bank Credit Cards – Features & Online Application
        </title>
        <meta
          name="description"
          content="Explore Federal Bank credit cards with exclusive benefits. Compare options and apply online today."
        />
        <meta
          name="keywords"
          content="abank of baroda lifetime free credit card, bob easy credit card apply, bank of baroda hpcl credit card, bank of baroda snapdeal credit card, bobcard payment"
        />
        <link
          rel="canonical"
          href="https://thefinmaster.com/federal-bank/credit-card"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      <div className="w-full flex justify-center items-center px-4 mt-20">
  <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
  <AdBanner displayOrder="1" />
  </div>
</div>
      <div className="w-full flex flex-col items-center ">
        <div className="w-full flex flex-col items-center ">
          <div className=" mt-10 w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600">
            <h1 className="text-white text-4xl md:text-7xl text-center font-medium">
              Federal Bank Credit Cards
            </h1>
            <p className="text-gray-200 text-lg md:text-2xl pt-2 px-4 text-center">
              Experience financial freedom and flexibility with our credit card
              options.
            </p>
          </div>
        </div>
        <div className="flex justify-center items-center  p-4 ">
          <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center mt-4">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
              Smart, Secure & Modern Cards Designed for the Digital Age{" "}
            </h2>

            <p className="text-gray-600 leading-relaxed mt-3">
              Federal Bank, one of India’s leading private sector banks, offers
              a range of innovative credit cards built with digital-first
              features and rewarding benefits. Known for seamless banking and
              technology integration, Federal Bank credit cards are ideal for
              millennials, digital-savvy users, and frequent online shoppers.
              From cashback on everyday spends to lifestyle privileges, each
              card is equipped with tailored features, low forex markups, and
              flexible reward programs—making them a smart choice for both
              domestic and international use.
            </p>
          </div>
        </div>
        <h2 className="text-center text-2xl md:text-3xl font-bold text-gray-800 my-10">
          Featured Credit Cards
        </h2>
        <div className="w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10">
          <div className="w-fit flex flex-col gap-8">
            {currentCards &&
              currentCards.map((item, index) => {
                return (
                  <>
                    {" "}
                    <CardComponent
                       key={index}
                       cardDetails={item}
                       Card_features={item?.Card_features}
                       fees={item?.fees}
                       cardName={item?.title}
                       cardImage={item?.image}
                       rating={item?.rating}
                       category={item?.category}
                       status={item?.status}
                       bank_link={item?.bank_link}
                    />{" "}
                  </>
                );
              })}
          </div>

           <div className="w-full relative ">
                     <div className="sticky overflow-hidden top-20 w-full h-[500px] flex flex-col justify-between">
                       {/* <div className="w-[70%] mx-auto">
                                                  <h2 className="text-center font-medium pt-5 text-lg">
                                                    <span className="font-semibold text-white">816 people</span>{" "}
                                                    are on call with our advisors right now
                                                  </h2>
                                                </div> */}
                       <div className="w-full mx-auto">
                        
                           <div className="w-[80%] mx-auto ">
                           <AdBanner displayOrder="2" />                           </div>
                     
                         <div className="bg-white">
                           {/* <h3 className="text-center text-blue-500 cursor-pointer font-semibold py-2">
                                                      Know your advisor
                                                    </h3> */}
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
        {/* Pagination */}
        <ul className="flex justify-center mt-4">
          {currentCards &&
            CreditCardData.cards?.filter(
              (card) => card.category === "Credit card"
            ).length > 0 &&
            Math.ceil(
              CreditCardData.cards?.filter(
                (card) => card.category === "Credit card"
              ).length / cardsPerPage
            ) > 1 &&
            Array.from({
              length: Math.ceil(
                CreditCardData.cards?.filter(
                  (card) => card.category === "Credit card"
                ).length / cardsPerPage
              ),
            }).map((_, index) => (
              <li key={index} className="mx-1">
                <button
                  className={`px-3 py-1 rounded-lg ${
                    currentPage === index + 1
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-800"
                  }`}
                  onClick={() => paginate(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
        </ul>

    

        {/* <div className='w-[95%] py-10'>
                                         <h1 className='text-center font-bold text-5xl my-10'>Frequently Asked Questions</h1>
                                         <AccordionComponent />
                                     </div> */}

        <div className="w-full px-2 py-2 bg-gradient-to-br from-sky-50 via-white to-sky-100 dark:from-gray-900 dark:to-gray-800">
          <div className="max-w-6xl mx-auto grid gap-10">
            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-sky-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <FileText className="w-8 h-8 text-sky-600" />
                <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                  Eligibility Criteria to Apply for Federal Bank Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Age Requirement
                  </span>
                  <span>
                    {" "}
                    Applicants must be between 21 to 60 years of age. Add-on
                    cardholders can be as young as 18 years.{" "}
                  </span>
                </div>

                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Minimum Income Requirement
                  </span>
                  <span>
                    {" "}
                    Salaried: Monthly income of ₹20,000 or more.Self-employed:
                    Must present stable income proof via recent ITR filings{" "}
                  </span>{" "}
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                  Credit Score Requirement
                  </span>
                  <span>
                    {" "}
                    A minimum CIBIL score of 700 is preferred. A clean repayment history significantly improves approval chances.{" "}
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                  Occupation Eligibility
                  </span>
                  <span>
                    {" "}
                    Both salaried professionals and self-employed individuals are eligible. Pensioners may also apply if they receive regular income.
                    {" "}
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                  Geographic Availability
                  </span>
                  <span>
                    {" "}
                    Some Federal Bank cards may be offered in select cities or states, depending on partnerships and network reach.
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-emerald-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <BadgeCheck className="w-8 h-8 text-emerald-600" />
                <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                Documents Required to Apply for Federal Bank Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Identity Proof
                  </span>
                  <span>
                    {" "}
                    Submit government-issued IDs like Aadhaar, Voter ID, Passport, or PAN Card for identity verification.

                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                  Address Proof
                  </span>
                  <span>
                    {" "}
                    Provide utility bills, Aadhaar card, passport, or driver’s license showing your current residence.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Proof of Income
                  </span>
                  <span>
                    {" "}
                    Salaried: Last 3 months’ salary slips and Form 16. Self-employed: Latest ITR, GST filings, and bank account statements.
                    </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Photograph
                  </span>
                  <span>
                    {" "}
                    One passport-sized recent photograph is required during submission (especially for in-branch applications).{" "}
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl sm:col-span-2">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    PAN Card
                  </span>
                  <span>
                    {" "}
                    A mandatory document for credit verification, tax compliance, and application processing.{" "}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
       <div className="w-full flex justify-center items-center my-6 px-4">
                <div className="w-full max-w-[984px]">
      
           
              <AdBanner displayOrder="3" />
              </div>
               
              </div>
      <div className="px-4 py-10 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center mb-4">
        How to Apply for Federal Bank Credit Card
        </h2>
        {/* <p className="text-gray-600 text-sm md:text-base mt-2 text-center mb-8">
                                   Applying for a fuel credit card is a seamless process that starts with
                                   the right research and ends at the official bank’s platform for final
                                   submission. Here’s how you can get started through TheFinMaster.com:
                                 </p> */}
        <div className="grid gap-6 md:grid-cols-2">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="flex items-start gap-4 p-4 rounded-xl bg-white dark:bg-gray-900 shadow-md border hover:shadow-lg transition"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="mt-1">{step.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">{`${
                  index + 1
                }. ${step.title}`}</h3>
                <p className="text-md text-gray-600 dark:text-gray-300">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <div className="max-w-4xl mx-auto py-6 px-2">
        <h2 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Federal;
